module.exports = __webpack_public_path__ + "static/media/wheel.2d2582e3.png";